import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import { createRequestCacheKey, fetchWithCache, invalidateRequestCache } from '../helpers/requestCache';

const FONT_DETAILS_TTL_MS = 60 * 60 * 1000;
const fontDetailsCacheKey = () => createRequestCacheKey('config', 'font-details');

export const fontService = {
    fetchFontDetails,
    invalidateFontDetailsCache
};

function fetchFontDetails(forceRefresh = false) {
    return fetchWithCache({
        key: fontDetailsCacheKey(),
        ttlMs: FONT_DETAILS_TTL_MS,
        forceRefresh,
        loader: () => apiClient.get(api.config.fetchFontDetails)
            .then(handleResponse)
            .then(data => data),
    })
        .catch(error => handleError(error.response));
}

function invalidateFontDetailsCache() {
    invalidateRequestCache(fontDetailsCacheKey());
}
